<div class="d-flex flex-column justify-content-center align-items-center modal-product" style="padding:30px 10px;">
    <form [formGroup]="editForm" (ngSubmit)="onSubmit()"
        class="d-flex flex-column justify-content-center align-items-center w-100">
        <div class="dialog-title">
            <h2>{{ getTitle() }}</h2>
            <button mat-icon-button aria-label="close dialog" mat-dialog-close tabindex="-1"
                style="position:absolute; top:0; right:0;">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <mat-dialog-content class="w-100">
            <input type="hidden" id="id" name="id" formControlName="id">
            <div class="d-flex flex-column justify-content-between p-2">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label for="description">Opis</mat-label>
                    <input matInput tabindex="1" type="text" formControlName="description" required>
                </mat-form-field>
                
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label for="type">Typ</mat-label>
                    <mat-select formControlName="type" required>
                        <mat-option value="SERVICE_CARD">Karta serwisowa</mat-option>
                        <mat-option value="INTEGRATION_CARD">Karta integracyjna</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label for="uuid">UUID</mat-label>
                    <input matInput tabindex="3" type="text" formControlName="uuid" required>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label for="pin">PIN</mat-label>
                    <input matInput tabindex="4" type="text" formControlName="pin" required>
                    <mat-error *ngIf="!editForm.controls['pin'].valid && editForm.controls['pin'].errors?.['maxlength']">Maksymalna długść PIN - 6 znaków</mat-error>
                    <mat-error *ngIf="!editForm.controls['pin'].valid && editForm.controls['pin'].errors?.['minlength']">Minimalna długść PIN - 4 znaki</mat-error>
                </mat-form-field>

                <div class="d-flex flex-row" style="margin-bottom: 20px;margin-top: 20px;">
                    <div class="d-flex w-50 align-content-center justify-content-start">
                        <mat-slide-toggle class="example-margin" formControlName="active">
                            Karta aktywna
                        </mat-slide-toggle>
                    </div>

                </div>
            </div>
            <mat-dialog-actions class="d-flex flex-row justify-content-between w-100 p-2">
                <button mat-flat-button color="warn" mat-dialog-close class="w-b w-40">Powrót</button>
                <button mat-flat-button color="accent" type="submit" [disabled]="checkDisabled()" class="w-b w-40">{{
                    getSaveText() }}</button>
            </mat-dialog-actions>
        </mat-dialog-content>
    </form>
</div>